<template>
  <notificationGroup group="top" class="">
    <div class="position-absolute d-block pointer-events-none link-notif-group">
      <notification v-slot="{ notifications, close }">
        <div
          class="d-flex max-w-sm w-100 mx-auto bg-white shadow-md rounded-lg overflow-hidden mt-4"
          v-for="notification in notifications"
          :key="notification.id"  @click="close(notification.id)">
          <div v-if="!notification.error" class="d-flex justify-content-center align-items-center notification-zone bg-green-500">
            <svg
              class="h-6 w-6 fill-current text-white"
              viewBox="0 0 40 40"
              >
              <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z">
              </path>
            </svg>
          </div>
          <div v-else class="d-flex justify-content-center align-items-center px-3 bg-red-500">
            <svg class="h-6 w-6 fill-current text-white" viewBox="0 0 40 40">
              <path d="M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z">
              </path>
            </svg>
          </div>

          <div class="py-2 px-3 d-flex w-100 justify-content-between">
            <div @click="notification.ntfAction">
              <span :class="[notification.error ? 'text-red-500' : 'text-green-500']" class="font-semibold">{{
                getNotificationTitleEncoding(notification)
              }}</span>
              <div v-for="text in notification.textBlocs" :key="'text-'+notification.id">
                <p class="text-sm">{{ text }}</p>
              </div>
            </div>
            <div>
              <i class="fa fa-times fs-14px"></i>
            </div>
          </div>
        </div>
      </notification>
    </div>
  </notificationGroup>
</template>

<script>

export default {
  data: () => {
    return {
    }
  },
  created () {
    this.$bus.$off('rtp-notif')
    this.$bus.$on('rtp-notif', data => {
      this.$notify({
        group: 'top',
        ntfAction: data.ntfAction ? data.ntfAction : () => {},
        title: data.title,
        textBlocs: data.description,
        error: data.error,
        encoded: data.encoded
      }, 60000)
    })
  },
  methods: {
    fixIE (data) {
      data = data.split(String.fromCharCode(402)).join(String.fromCharCode(131))
      data = data.split(String.fromCharCode(210)).join(String.fromCharCode(195))
      return data
    },
    getNotificationTitleEncoding (notification) {
      if (notification.encoded) {
        let decoded = notification.title
        try {
          decoded = utf8.decode(this.fixIE(decoded))
          try {
            decoded = utf8.decode(this.fixIE(decoded))
          } catch (inErr) {
            return decoded
          }
        } catch (err) {
          return decoded
        }
        return decoded
      } else {
        return notification.title
      }
    }
  }
}
</script>

<style scoped>
/* tailwind css */
.shadow-md {
  box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
}
.rounded-lg	{
  border-radius: 0.5rem;
}
.fill-current	{
  fill: currentColor;
}
.bg-green-500 {
  background-color: rgba(6.3%, 72.5%, 50.6%, 1);
}
.bg-red-500 {
  background-color: rgba(93.7%, 26.6%, 26.6%, 1);
}
.h-6 {
  height: 1.5rem;
}
.w-6 {
  width: 1.5rem;
}
.w-12	{
  width: 3rem;
}
.max-w-sm {
  max-width: 24rem;
}
.mt-4	{
  margin-top: 1rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.notification-zone {
  padding: 0.75rem;
}

.text-green-500 {
  --tw-text-opacity: 1;
  color: rgba(16, 185, 129, var(--tw-text-opacity));
}
.font-semibold {
  font-weight: 600;
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.link-notif-group {
  top: 40px;
  right: 0px;
  width: 350px;
}
</style>
